export default {
  title: 'Maksutiedot vahvistettu',
  description: 'Maksutietosi on vahvistettu onnistuneesti.',
};
